import { AutocompleteProps } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { NewAutoCompleteField } from "../form/AutocompleteField";

export interface Option {
  value: any;
  label: string;
  img?: string;
}

export interface FieldsExpectedValues {
  field: string;
  expectedValues: {
    description: string;
    value: string;
  }[];
}

interface RHFAutocompleteProps {
  name: string;
  dense?: boolean;
  label?: string;
  disabled?: boolean;
  options: Option[];
  onExternalChange?: (value: Option | string) => void;
  sx?: any;
}

const RHFAutocomplete = (
  props: RHFAutocompleteProps &
    Omit<
      AutocompleteProps<any, boolean, boolean, boolean, any>,
      "onChange" | "renderInput"
    >,
) => {
  const {
    name,
    options,
    dense = false,
    label,
    disabled,
    freeSolo,
    onExternalChange,

    ...other
  } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const { onChange, onBlur, value, ref } = field;

        const handleChange = (newValue: Option | string) =>
          onChange(
            typeof newValue === "string" ? newValue : newValue?.value ?? null,
          );

        const getValue = () =>
          value
            ? options.find((option) => {
                return value === option.value;
              }) ?? (freeSolo ? value : null)
            : null;

        return (
          <>
            <NewAutoCompleteField
              label={label}
              value={getValue()}
              onChange={(event: any, newValue: Option | string) => {
                if (onExternalChange) {
                  onExternalChange(newValue);
                  return;
                }
                handleChange(newValue);
              }}
              options={options}
              error={error?.message}
              disabled={disabled}
              freeSolo={freeSolo}
              onBlur={onBlur}
              {...other}
            />
          </>
        );
      }}
    />
  );
};

export default RHFAutocomplete;
